import React from 'react';
import Booking from '../sections/sec-booking';
import './home.css'

const Bookingmangemnet = () => {
    return ( 
        <>
        <section className='home'>
                <div className='circle-dec-sec1'></div>
                <div className='circl2-sec1-dec'></div>
                <Booking />
        </section>
        </>
     );
}
 
export default Bookingmangemnet;